import { render, staticRenderFns } from "./PeriodFilter.vue?vue&type=template&id=05b53b5c&scoped=true"
import script from "./PeriodFilter.vue?vue&type=script&lang=js"
export * from "./PeriodFilter.vue?vue&type=script&lang=js"
import style0 from "./PeriodFilter.vue?vue&type=style&index=0&id=05b53b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b53b5c",
  null
  
)

export default component.exports